(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', 'react-router-dom', './withAuthProvider', './Spinner', './utils'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('react-router-dom'), require('./withAuthProvider'), require('./Spinner'), require('./utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.inherits, global.react, global.reactRouterDom, global.withAuthProvider, global.Spinner, global.utils);
    global.PrivateRoute = mod.exports;
  }
})(this, function (exports, _extends2, _objectWithoutProperties2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _inherits2, _react, _reactRouterDom, _withAuthProvider, _Spinner, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PrivateRoute = exports.RedirectToLogin = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _createClass3 = _interopRequireDefault(_createClass2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react2 = _interopRequireDefault(_react);

  var _withAuthProvider2 = _interopRequireDefault(_withAuthProvider);

  var _Spinner2 = _interopRequireDefault(_Spinner);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var RedirectToLogin = exports.RedirectToLogin = function (_React$Component) {
    (0, _inherits3.default)(RedirectToLogin, _React$Component);

    function RedirectToLogin() {
      (0, _classCallCheck3.default)(this, RedirectToLogin);
      return (0, _possibleConstructorReturn3.default)(this, (RedirectToLogin.__proto__ || Object.getPrototypeOf(RedirectToLogin)).apply(this, arguments));
    }

    (0, _createClass3.default)(RedirectToLogin, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var returnTo = this.props.returnTo || window.location;
        window.location.assign(process.env.REACT_APP_AUTH_FLOW_BASE_URI + '/login?return_to=' + returnTo);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return RedirectToLogin;
  }(_react2.default.Component);

  var PrivateRoute = function PrivateRoute(_ref) {
    var authReady = _ref.authReady,
        me = _ref.me,
        returnTo = _ref.returnTo,
        _ref$loader = _ref.loader,
        Loader = _ref$loader === undefined ? _Spinner2.default : _ref$loader,
        PrivateComponent = _ref.component,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['authReady', 'me', 'returnTo', 'loader', 'component']);
    return !authReady ? _react2.default.createElement(Loader, null) : _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
      render: function render(renderProps) {
        return (0, _utils.checkLogin)(rest) ? _react2.default.createElement(PrivateComponent, renderProps) : _react2.default.createElement(RedirectToLogin, { returnTo: returnTo });
      }
    }));
  };

  exports.PrivateRoute = PrivateRoute;
  exports.default = (0, _withAuthProvider2.default)(PrivateRoute);
});